import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { ComponentTitle, ComponentBody } from "./Common";
import { AddCommaNumber } from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";

export default (props) => {
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: <div style={{ textAlign: "center" }}>{props.title}</div>,
          columns: [
            {
              Header: (
                <div className="text-center">
                  <IntlMessages id="analytics.table.stt" />
                </div>
              ),
              accessor: "stt",
              width: 40,
              Cell: (_props) => (
                <div className="text-center">{_props.value}</div>
              ),
            },
            {
              Header: (
                <div className="text-left">
                  <IntlMessages id="analytics.table.product" />
                </div>
              ),
              accessor: "label",
              minWidth: 100,
              Cell: (_props) => (
                <div
                  className="text-left"
                  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {_props.value}
                </div>
              ),
            },
            {
              Header: (
                <div className="text-center">
                  <ComponentTitle
                    compare={props.setting.compare}
                    title={<IntlMessages id="analytics.table.sold_quantity" />}
                    value={props.total_count}
                    align="center"
                  />
                </div>
              ),
              accessor: "count",
              width: 90,
              Cell: (_props) => {
                const value = _props.value + " SP";
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_count}
                  />
                );
              },
            },
            {
              Header: (
                <div className="text-right">
                  <ComponentTitle
                    compare={props.setting.compare}
                    title={<IntlMessages id="analytics.table.revenue" />}
                    value={AddCommaNumber(props.total_price)}
                    align="end"
                  />
                </div>
              ),
              width: 150,
              accessor: "price",
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => (
                <ComponentBody
                  compare={props.setting.compare}
                  all={props.setting.all}
                  type="price"
                  align="end"
                  value={_props.value}
                  compare_value={_props.original.compare_price}
                />
              ),
            },
            {
              Header: (
                <div className="text-right">
                  <IntlMessages id="analytics.table.cogs" />
                </div>
              ),
              accessor: "cost",
              width: 85,
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => (
                <div className="text-right text-muted">
                  {AddCommaNumber(_props.value || 0)}
                </div>
              ),
            },
            {
              Header: (
                <div className="text-right">
                  <IntlMessages id="analytics.table.profit" />
                </div>
              ),
              accessor: "gross_profit",
              width: 90,
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => {
                const value = _props.value || 0;
                return (
                  <div
                    className={`text-right font-weight-bold ${
                      value >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    {AddCommaNumber(value)}
                  </div>
                );
              },
            },
            {
              Header: (
                <div className="text-center">
                  <IntlMessages id="analytics.table.ratio" />
                </div>
              ),
              accessor: "profit_margin",
              width: 60,
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => {
                const margin = _props.value || 0;
                let bgColor = "#dc3545"; // red < 20%
                if (margin >= 50)
                  bgColor = "#28a745"; // green >= 50%
                else if (margin >= 30)
                  bgColor = "#17a2b8"; // cyan >= 30%
                else if (margin >= 20) bgColor = "#ffc107"; // yellow >= 20%

                return (
                  <div className="text-center">
                    <span
                      className="badge"
                      style={{
                        backgroundColor: bgColor,
                        color: margin >= 20 && margin < 30 ? "#000" : "#fff",
                        fontSize: "11px",
                        padding: "3px 5px",
                      }}
                    >
                      {margin}%
                    </span>
                  </div>
                );
              },
            },
          ],
        },
      ],
    });
  }, [props.data, props.setting.compare, props.setting.all]);

  return (
    <ReactTable
      defaultPageSize={5}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={false}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
      getTrProps={(tableState, rowInfo) => ({
        onClick: () => {
          if (rowInfo && props.onProductSelect) props.onProductSelect(rowInfo.original);
        },
        style: {
          cursor: rowInfo && props.onProductSelect ? "pointer" : "default",
        },
        title: rowInfo && props.onProductSelect ? "Xem khách hàng đã mua" : undefined,
      })}
    />
  );
};
